import "./Auth.css";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../components/Logo/Logo";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFirebase } from "../../../contexts/FirebaseContext";
import SharedPageWrapper from "../../components/SharedPageWrapper/SharedPageWrapper";
import { TextField } from "@mui/material";

export default function SignIn() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { auth } = useFirebase();
    const location = useLocation();
    const navigate = useNavigate();

    // Determine game theme from URL params or location state
    const searchParams = new URLSearchParams(location.search);
    const game = searchParams.get('game') || location.state?.game || 'mk8dx';

    const signIn = (e) => {
        e.preventDefault();

        signInWithEmailAndPassword(auth, email, password)
            .then(() => {
                navigate("/", { replace: true, state: { yourCup: location.state?.yourCup } });
            })
            .catch((error) => setErrorMessage(error.message));
    }

    return <SharedPageWrapper game={game}>
        <div id="auth-container">
        <div id="form-title">
            <Logo game={game} />
            <h1>Sign in</h1>
        </div>
        <form className="auth-form" onSubmit={signIn}>

            <h3 id="auth-error">{errorMessage}</h3>

            <TextField
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username email"
                variant="outlined"
                className="auth-textfield"
                sx={{
                    width: '350px',
                    marginBottom: '20px',
                    '& .MuiOutlinedInput-root': {
                        color: 'white',
                        backgroundColor: '#555',
                        '& fieldset': {
                            borderColor: '#777',
                        },
                        '&:hover fieldset': {
                            borderColor: 'white',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'white',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        color: '#aaa',
                        fontFamily: 'var(--ui-font-family)',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                        color: 'white',
                    },
                    '& input': {
                        fontFamily: 'var(--ui-font-family)',
                    },
                }}
            />

            <TextField
                label="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                autoComplete="current-password"
                variant="outlined"
                className="auth-textfield"
                sx={{
                    width: '350px',
                    marginBottom: '20px',
                    '& .MuiOutlinedInput-root': {
                        color: 'white',
                        backgroundColor: '#555',
                        '& fieldset': {
                            borderColor: '#777',
                        },
                        '&:hover fieldset': {
                            borderColor: 'white',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'white',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        color: '#aaa',
                        fontFamily: 'var(--ui-font-family)',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                        color: 'white',
                    },
                    '& input': {
                        fontFamily: 'var(--ui-font-family)',
                    },
                }}
            />

            <input type="submit" value="Sign In" className="icon-button" />

            <Link to={`/forgot-password?game=${game}`} state={{ yourCup: location.state?.yourCup, game }}>Forgot password</Link>

        </form>

        <Link to={`/signup?game=${game}`} state={{ yourCup: location.state?.yourCup, game }}>Don't have an account? Sign Up</Link>
    </div>
    </SharedPageWrapper>
}